import { berachain as viemBerachain } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const berachain = {
  displayName: 'Berachain',
  runtime: 'evm',
  viemChain: viemBerachain,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 15,

  decoration: {
    color: '#FE740D',
    contrastColor: getContrastColor('#FE740D'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'bera-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://berascan.com',
        token: 'https://berascan.com/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '100000020',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    stargate: { chainKey: 'bera' },
    relay: {},
    kyberswap: { chainKey: 'berachain' },
  }),
  services: defaultServices({
    codex: {
      networkId: 80094,
      nativeLiquidityAddress: '0x6969696969696969696969696969696969696969',
    },
    defiLlama: { chainKeys: ['berachain'] },
    zerion: { chainKey: 'berachain' },
    trm: { chainKey: 'berachain' },
    coingecko: {
      networkId: 'berachain',
      platformId: 'berachain',
    },
    coingeckoDex: {
      networkId: 'berachain',
    },
    qnStreams: {
      networkKey: 'bera-mainnet',
    },
    safe: { shortName: 'berachain' },
    alchemy: { chainSlug: 'berachain-mainnet' },
    pimlico: { chainSlug: 'berachain' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
